import AgeBanner from "../components/AgeBanner";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";
import { usePageTitle } from "../hook/usePageTitle";

const PrivacyPolicyPage = () => {
  usePageTitle("Privacy Policy");
  return (
    <>
      <AgeBanner />
      <Navigation />
      <div className="policy-page">
        <div className="policy-hero">
          <h1>Privacy <span className="highlight">Policy</span></h1>
        </div>

        <div className="policy-content">
          <p className="last-updated">Last Updated: January 28, 2026</p>

          <h2>Introduction</h2>
          <p>Hyrano ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains
            how we collect, use, disclose, and safeguard your information when you visit our social casino
            entertainment platform.</p>
          <p>Please read this Privacy Policy carefully. By using Hyrano, you agree to the collection and use of
            information in accordance with this policy.</p>

          <h2>Information We Collect</h2>
          <p>We may collect information about you in various ways, including:</p>

          <h3>Automatically Collected Information</h3>
          <p>When you access Hyrano, we may automatically collect certain information, including:</p>
          <ul>
            <li><strong>Device Information:</strong> Browser type, operating system, device type</li>
            <li><strong>Usage Data:</strong> Pages visited, time spent on pages, game interactions</li>
            <li><strong>Technical Data:</strong> IP address, browser settings, time zone</li>
            <li><strong>Cookies and Similar Technologies:</strong> Session data, preferences</li>
          </ul>

          <h3>Information You Provide</h3>
          <p>If you choose to contact us or interact with certain features, you may provide:</p>
          <ul>
            <li>Contact information (if you reach out to us)</li>
            <li>Feedback or comments</li>
            <li>Any other information you voluntarily submit</li>
          </ul>

          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and maintain our Platform</li>
            <li>Improve user experience and Platform functionality</li>
            <li>Analyze usage patterns and trends</li>
            <li>Ensure security and prevent fraud</li>
            <li>Comply with legal obligations</li>
            <li>Respond to inquiries and provide support</li>
            <li>Personalize your gaming experience</li>
          </ul>

          <h2>Cookies and Tracking Technologies</h2>
          <p>We use cookies and similar tracking technologies to enhance your experience on Hyrano. Cookies are
            small data files stored on your device that help us:</p>
          <ul>
            <li>Remember your preferences and settings</li>
            <li>Understand how you use our Platform</li>
            <li>Improve Platform performance</li>
            <li>Provide relevant content</li>
          </ul>
          <p>You can control cookie preferences through your browser settings. However, disabling cookies may affect
            your experience on the Platform.</p>

          <h2>Data Sharing and Disclosure</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share information in
            the following circumstances:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third parties who assist in operating our Platform</li>
            <li><strong>Legal Requirements:</strong> When required by law or legal process</li>
            <li><strong>Protection of Rights:</strong> To protect our rights, privacy, safety, or property</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets
            </li>
          </ul>

          <h2>Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your information against
            unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the
            Internet or electronic storage is 100% secure.</p>

          <h2>Data Retention</h2>
          <p>We retain your information for as long as necessary to fulfill the purposes outlined in this Privacy
            Policy, unless a longer retention period is required or permitted by law.</p>

          <h2>Your Rights</h2>
          <p>Depending on your jurisdiction, you may have certain rights regarding your personal information,
            including:</p>
          <ul>
            <li>The right to access your personal information</li>
            <li>The right to correct inaccurate data</li>
            <li>The right to request deletion of your data</li>
            <li>The right to restrict or object to processing</li>
            <li>The right to data portability</li>
            <li>The right to withdraw consent</li>
          </ul>

          <h2>Children's Privacy</h2>
          <p>Hyrano is intended for users who are <strong>18 years of age or older</strong>. We do not knowingly
            collect personal information from children under 18. If we become aware that we have collected
            information from a child under 18, we will take steps to delete such information.</p>

          <h2>International Users</h2>
          <p>If you access Hyrano from outside our primary jurisdiction, please be aware that your information
            may be transferred to, stored, and processed in a different location. By using our Platform, you consent
            to such transfers.</p>

          <h2>Third-Party Links</h2>
          <p>Hyrano does not contain links to external websites or third-party services. All content and
            functionality is contained within our Platform.</p>

          <h2>Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new
            Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy
            Policy periodically for any changes.</p>

          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or our data practices, please navigate to our contact
            section on the homepage.</p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;